import { ApolloError, useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'
import { GET_PAIRING_DATA } from '../queries/Pairings'
import {
  LSPAYPairing,
  LSPAYPairingData,
  LSPAYPairingRequest,
} from '../helpers/lspay.types'
import { LSPAY_SERVER_DRIVEN_SUPPORTED_DEVICES } from '../helpers/lspayConstants'

export const useFetchPairing = (
  registerId: string
): {
  loading: boolean
  pairing: LSPAYPairing | undefined
  error: ApolloError | undefined
  refetch: () => void
  isServerDrivenSupported: boolean
} => {
  const { loading: queryLoading, error, data, refetch } = useQuery<
    LSPAYPairingData,
    LSPAYPairingRequest
  >(GET_PAIRING_DATA, {
    fetchPolicy: 'network-only',
    variables: { registerID: registerId },
  })
  const [loading, setLoading] = useState(true)
  const [isServerDrivenSupported, setServerDrivenSupport] = useState(false)
  const pairing = data?.lspayPairings?.[0]

  useEffect(() => {
    if (!queryLoading && error) {
      setLoading(false)
      return
    }
    if (!queryLoading && data) {
      const pairing = data.lspayPairings?.[0]
      if (!pairing) {
        // If there is no pairing or pairing list is empty, use the server-driven flow
        setServerDrivenSupport(true)
      } else {
        // Check device type to decide the flow
        const deviceType = pairing.deviceType ?? 'unknown'
        setServerDrivenSupport(
          Object.values(LSPAY_SERVER_DRIVEN_SUPPORTED_DEVICES).includes(
            deviceType as LSPAY_SERVER_DRIVEN_SUPPORTED_DEVICES
          )
        )
      }
      setLoading(false) // Set loading to false after processing pairing logic
    }
  }, [queryLoading, data, error])
  return {
    loading: queryLoading || loading,
    pairing,
    error,
    refetch,
    isServerDrivenSupported,
  }
}
